import classNames from "classnames";
import React from "react";
import RivalsSquareIcon from "rivals/components/shared/Icons/RivalsSquareIcon";
import VersionHeader from "rivals/components/shared/RivalsListHeader/VersionHeader";
import VersioningDropdown from "rivals/components/shared/RivalsListHeader/VersioningDropdown";
import ShareModule from "rivals/components/shared/ShareModule";
import strings from "rivals/components/shared/ShareModule/strings";
import { TEAM_RANKING_TYPES } from "rivals/shared/constants";
import { useIsMobileWidth } from "rivals/shared/utils/mediaQuery";
import styles from "./index.module.scss";
import { OwnProps } from "./types";

const RivalsListHeader = ({
  currentVersion,
  disableShare = false,
  latestVersion,
  logoClassName,
  onSelectVersion,
  preventClosingVersionSelect,
  socialMediaPostText = strings.defaultPostText,
  socialMediaUrl,
  subtitle,
  subtitleColor,
  title,
  titleColor = styles["rivals-secondary"],
  type = TEAM_RANKING_TYPES.COMPREHENSIVE,
  versions,
  lastUpdated
}: OwnProps): JSX.Element => {
  const isMobile = useIsMobileWidth();

  const shareControlsEl = !disableShare && (
    <ShareModule postText={socialMediaPostText} url={socialMediaUrl} />
  );

  const versioningDropdownEl = versions &&
    currentVersion &&
    onSelectVersion && (
      <VersioningDropdown
        onSelect={onSelectVersion}
        preventClosing={preventClosingVersionSelect || false}
        selectedVersionId={currentVersion.listId}
        versions={versions}
      />
    );

  return (
    <>
      {currentVersion && latestVersion && (
        <VersionHeader
          latestVersion={latestVersion}
          onViewLatestVersion={(): void =>
            onSelectVersion && onSelectVersion(latestVersion)
          }
          version={currentVersion}
        />
      )}
      <div className={styles.mainContent}>
        <div className={styles.mainContentGroup1}>
          <div
            className={classNames(styles.logoAndTitleWrapper, {
              [styles.withSubtitle]: !!subtitle
            })}
          >
            <div className={classNames(styles.logoWrapper, logoClassName)}>
              <RivalsSquareIcon type={type} />
            </div>
            <div>
              <div className={styles.title} style={{ color: titleColor }}>
                {title}
              </div>
              {subtitle && (
                <div
                  className={styles.subtitle}
                  style={{ color: subtitleColor }}
                >
                  {subtitle}
                </div>
              )}
            </div>
          </div>
          {!isMobile && shareControlsEl}
          {!isMobile && versioningDropdownEl}
        </div>
        <div className={styles.mainContentGroup2}>
          {lastUpdated && (
            <div className={styles.lastUpdated}>
              <span className={styles.lastUpdatedLabel}>Last Updated: </span>
              <span className={styles.lastUpdatedValue}>{lastUpdated}</span>
            </div>
          )}
          {isMobile && versioningDropdownEl}
          {isMobile && shareControlsEl}
        </div>
      </div>
    </>
  );
};

export default RivalsListHeader;
